import { ContentTopic } from "api";

// Romanian labels for the bot content-sourcing topics. The value is the contract
// with sporapi/spor-bots and must never be translated — only these labels are.
export const CONTENT_TOPIC_LABELS: Record<ContentTopic, string> = {
  [ContentTopic.Sport]: "Sport",
  [ContentTopic.Monden]: "Monden",
  [ContentTopic.Global]: "Extern",
  [ContentTopic.Actualitate]: "Actualitate",
};

export const CONTENT_TOPIC_OPTIONS = Object.values(ContentTopic).map((topic) => ({
  value: topic,
  label: CONTENT_TOPIC_LABELS[topic],
}));
